export default __webpack_public_path__ + "static/media/Bg2.3d64f7b4.png";